import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import EditIcon from '@material-ui/icons/Edit'
import PropTypes from 'prop-types'
import React from 'react'

export default class OrganizationEditDialog extends React.Component {
    static propTypes = {
        item: PropTypes.object.isRequired,
        open: PropTypes.bool.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        onOpen: PropTypes.func.isRequired
    }

    state = {
        name: this.props.item.name,
        token: this.props.item.token
    }

    handleClickOpen = () => {
        const { onOpen, item } = this.props
        onOpen(item.id)
    }

    handleClose = () => {
        this.props.onClose()
    }

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleSave = () => {
        const { item, onUpdate } = this.props
        const { name, token } = this.state

        onUpdate({
            ...item,
            name,
            token
        })
        this.handleClose()
    }

    render() {
        const { open, item } = this.props
        const { name, token } = this.state
        return (
            <div>
                <IconButton aria-label="Edit" onClick={this.handleClickOpen}>
                    <EditIcon />
                </IconButton>

                <Dialog open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Редактирование организации (Remote ID: {item.id})</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            value={name}
                            name="name"
                            id="name"
                            label="Имя организации Dobovo.com"
                            onChange={this.handleChange}
                            fullWidth
                        />

                        <TextField
                            margin="dense"
                            value={token}
                            name="token"
                            id="token"
                            label="Token"
                            onChange={this.handleChange}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Отмена
                        </Button>
                        <Button onClick={this.handleSave} color="primary">
                            Сохранить
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/OrganizationTab/OrganizationTable/OrganizationEditDialog.js